import { Component, Inject, OnInit } from '@angular/core';

import { Env, Projects, ProjectsFilter } from '@usimweb/core/models';
import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';

import { Observable, skip } from 'rxjs';

import { Store } from '@ngrx/store';
import * as fromStore from '@usimweb/state/store';
import { DialogService, Disclaimer } from '@usimweb/ui/dialogs';
import { DialogHandler } from './dialogHandler';

@Component({
  selector: 'usimweb-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  standalone: false,
})
export class ProjectsComponent extends DialogHandler implements OnInit {
  public projects$!: Observable<Projects[]>;
  public progress$!: Observable<boolean>;
  public projects!: Projects[];

  public emptyProjectLink!: string;
  public projectLink!: string;

  constructor(
    @Inject('environment') private environment: Env,
    private store: Store<fromStore.DashboardState>,
    private authHandler: AuthHandler,
    private dialogService: DialogService,
    private apiService: ApiService,
    private disclaimer: Disclaimer
  ) {
    super(store, dialogService, apiService, disclaimer);
    this.emptyProjectLink = this.environment.emptyProjectLink;
    this.projectLink = this.environment.projectLink;
  }

  ngOnInit(): void {
    this.openTouDialog(this.environment);

    this.store.dispatch(new fromStore.ClearVersions());

    this.authHandler.authenticated().subscribe((result: boolean) => {
      this.getProjects();
      // this.refreshCallback.pipe(skip(1)).subscribe(() => {
      //   this.store.dispatch(new fromStore.LoadProjects());
      // });
    });
  }

  private getProjects() {
    this.projects$ = this.store.select<Projects[]>(fromStore.getAllProjects);
    this.progress$ = this.store.select<boolean>(fromStore.getProjectsLoading);
  }

  public favouriteChanged(project: Projects) {
    this.store.dispatch(new fromStore.FavProject(project));
  }

  public filter(filter: ProjectsFilter) {
    this.store.dispatch(new fromStore.SetProjectsFilter(filter));
  }

  public openDialog(event: any) {
    this.open(event);
  }
}
